import {
    ComponentProps as OverviewComponentProps
} from '~/frontend/src/components/base/Overview';


export default {
    hydrate( inboundState : OverviewComponentProps ) : OverviewComponentProps {
        const retVal = {
            ...inboundState
        };

        return retVal;
    },

    rehydrate( outboundState : OverviewComponentProps ) : OverviewComponentProps {
        return outboundState;
    }
};
